import { ExportJobDocumentationChanges, PublishedDocEnvironment, } from "@supernova-studio/model";
import { DTOExportJob } from "../export";
import { z } from "zod";
export const DTOPublishDocumentationChanges = ExportJobDocumentationChanges;
export const DTOPublishDocumentationRequest = z.object({
    environment: PublishedDocEnvironment,
    /**
     * If defined, this allows narrowing down what is published to a set of specific pages and groups
     * If undefined, everything will be published.
     */
    changes: DTOPublishDocumentationChanges.optional(),
});
export const DTOPublishDocumentationResponse = z.object({
    job: DTOExportJob,
});
